export type ValuationTabKind = 'calibration' | 'range_sensitivity' | 'opm_calculator' | 'approach';

const panelSlug = (panelId: string) => String(panelId ?? '').replaceAll('-', '_');

/**
 * Stable string ids for valuation approach tabs (URL `?tab=` and tab strip).
 *
 * `id` is a panel id for `calibration` / `range_sensitivity` / `opm_calculator` (slugged in the
 * result), or an approach table name for `approach`.
 */
export function valuationTabId(kind: ValuationTabKind, id: string): string {
  if (kind === 'calibration') {
    return `cal-${panelSlug(id)}`;
  }
  if (kind === 'range_sensitivity') {
    return `rs-${panelSlug(id)}`;
  }
  if (kind === 'opm_calculator') {
    return `opm-${panelSlug(id)}`;
  }
  return `${id}`;
}
